import { useEffect, useRef, useState } from 'react';

export const useIntersection = (element, rootMargin, threshold, multipleObserve = false) => {
  const [isVisible, setIsVisible] = useState(false);
  const observerRef = useRef(null);

  useEffect(() => {
    // Early return if element is not available or IntersectionObserver is not supported
    if (!element?.current || typeof IntersectionObserver === 'undefined') {
      return undefined;
    }

    const currentElement = element.current;

    const observerCallback = ([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        if (!multipleObserve && observerRef.current) {
          observerRef.current.unobserve(currentElement);
        }
      } else if (multipleObserve) {
        setIsVisible(false);
      }
    };

    observerRef.current = new IntersectionObserver(observerCallback, {
      rootMargin,
      threshold,
    });

    observerRef.current.observe(currentElement);

    return () => {
      if (observerRef.current && currentElement) {
        observerRef.current.unobserve(currentElement);
      }
    };
  }, [element, rootMargin, threshold, multipleObserve]);

  return isVisible;
};
